import { Component, OnInit, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, selectAuthState, selectDoctorState } from '../../../store/app.states';
import { Patient } from '../../../model/user/Patient';
import { Observable } from 'rxjs';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import {
  GetPatients,
} from '../../../store/actions/doctor.actions';
import { DoctorService } from '../../../services/doctor.service';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../user-actions/confirm-dialog/confirm-dialog.component';
import { ErrorDialogComponent } from '../../user-actions/error-dialog/error-dialog.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as clinicalDataFile from '../../../../assets/clinicalData.json';
import { MatCheckboxChange } from "@angular/material/checkbox";

@Component({
  selector: 'app-patients',
  templateUrl: './patients-control-panel.component.html',
  styleUrls: ['./patients-control-panel.component.css'],
})

export class PatientsControlPanelComponent implements OnInit {
  // variabili per il controllo sugli utenti senza variabili cliniche inserite
  noClinicalDataSelection = false;
  sendingMail = false;
  patientsNoClinicalData: Patient[] = [];
  dataSourceNoClinicalData;
  // variabile boolean per il simbolo di warning sugli utenti senza dati clinici inseriti
  boolean: boolean;
  //
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  patients: Patient[];
  dataSource;
  title = 'Pazienti personali';
  displayedColumns = ['surname', 'name', 'ssn', 'birthDate', 'category', 'card', 'questionnaires', 'email', 'remove'];
  patientSSN: string;
  totalSize = 0;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(private store: Store<AppState>,
    private router: Router,
    private doctorService: DoctorService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState);
    document.addEventListener('notification', () => {
      this.store.dispatch(new GetPatients());
      setTimeout(() => {
        this.patients = JSON.parse(localStorage.getItem('patients'));
        if (this.patients !== null && this.patients !== undefined) {
          this.patients.sort((p1, p2) => p1.surname < p2.surname ? -1 : 0);
        }
        this.dataSource.data = this.patients ? this.patients : [];
      }, 500);
    });
  }

  ngOnInit(): void {
    this.paginator._intl.itemsPerPageLabel = 'Pazienti per pagina';
    this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      //console.log(this.user);
      this.errorMessage = state.errorMessage;
    });

    this.doctorService.getPatients().subscribe((patients) => {
      localStorage.setItem('patients', JSON.stringify(patients));
      this.patients = patients;
      console.log(this.patients);
      if (this.patients !== null && this.patients !== undefined) {
        this.patients.sort((p1, p2) => p1.surname < p2.surname ? -1 : 0);
      }
      // creo una lista con i pazienti che non hanno dati clinici inseriti
      this.findPatientsNoClinicalData(patients);
      this.dataSource = new MatTableDataSource<Patient>(this.patients ? this.patients : []);
      this.dataSource.paginator = this.paginator;
      this.totalSize = this.patients.length;

      this.localStorageClear();
    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    });
  }

  localStorageClear() {

    const user = localStorage.getItem('user');
    const jwt = localStorage.getItem('jwt');
    const expirationTime = localStorage.getItem('expirationTime');
    const patients = localStorage.getItem('patients');
    const firebaseToken = localStorage.getItem('firebase-token');
    const doctorID = localStorage.getItem('doctorID');

    localStorage.clear();

    localStorage.setItem('user', user);
    localStorage.setItem('jwt', jwt);
    localStorage.setItem('expirationTime', expirationTime);
    localStorage.setItem('patients', patients);
    localStorage.setItem('firebase-token', firebaseToken);
    localStorage.setItem('doctorID', doctorID);
  }

  applyFilter(event: Event) {
    // metto un else per cercare sia nel datasource di tutti i pazienti, sia solo in
    // quelli dei pazienti con dati clinici mancanti
    const filterValue = (event.target as HTMLInputElement).value;
    if (this.noClinicalDataSelection === true) {
      this.dataSourceNoClinicalData.filter = filterValue.trim().toLowerCase();
      if (this.dataSourceNoClinicalData.paginator) {
        this.dataSourceNoClinicalData.paginator.firstPage();
      }
    } else {
      this.dataSource.filter = filterValue.trim().toLowerCase();
      if (this.dataSource.paginator) {
        this.dataSource.paginator.firstPage();
      }
    }
  }

  goToQuestionnaires(patientSSN: string) {
    this.router.navigateByUrl('/patient-questionnaire-panel/' + patientSSN + '/local');
  }

  openDeleteDialog(patient) {
    const message = 'Se confermata, questa operazione non potrà più essere annullata.';
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '500px',
      height: '265px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'SI') {
        this.doctorService.removePatient(patient).subscribe(d => {
          if (d.status === 200) {
            this.patients.forEach((p, index) => {
              if (p.ssn.localeCompare(patient.ssn) === 0) {
                this.patients.splice(index, 1);
              }
            });
            this.dataSource.data = this.patients;
            this.dataSource.sort = this.sort;
            this.store.dispatch(new GetPatients());
          }
        },
          error => {
            console.log(error);
            this.openErrorDialog('Qualcosa è andato storto. Le modifiche non verranno salvate.');
          });
      }
    });
  }

  openErrorDialog(message: string): void {
    const dialogRef = this.dialog.open(ErrorDialogComponent, {
      width: '500px',
      height: '270px',
      data: message
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('Finestra chiusa');
    });
  }

  openPanel(patient) {
    this.router.navigateByUrl('/patient-panel/' + patient.ssn + '/personal');
  }

  goToQuestionnairesSummary() {
    const doctorId = JSON.parse(localStorage.getItem('doctorID'));
    this.router.navigateByUrl('/patient-questionnaires-summary/' + doctorId);
  }

  goToInactivePatients() {
    const doctorId = JSON.parse(localStorage.getItem('doctorID'));
    this.router.navigateByUrl('/inactive-patients-summary/' + doctorId);
  }

  loadData() {
    // posto nel body ad una determinata URL il file con i dati clinici
    this.doctorService.postClinicalDataFile(clinicalDataFile).subscribe(response => {
      if (response.status === 200) {
        this.snackBar.open('dati inseriti correttamente!', 'Chiudi', {
          duration: 3000
        });
      } else {
        this.snackBar.open('Qualcosa è andato storto!', 'Chiudi', {
          duration: 3000
        });
      }
    }, error => {
      if (error.status === 500) {
        localStorage.setItem('expirationTime', '0');
        console.log('SESSIONE SCADUTA');
        location.reload();
      }
    });
  }
  controlClinicalData(patient) {
    return patient.checkClinicalData;
    /*
    if ((patient.bodyStat.age === null || patient.bodyStat.age === '' || patient.bodyStat.age === ' years') &&
      // tslint:disable-next-line:max-line-length
      (patient.bodyStat.ageOfDiagnosis === null || patient.bodyStat.ageOfDiagnosis === '' || patient.bodyStat.ageOfDiagnosis === ' years') &&
      (patient.bodyStat.attiveEIMS === null || patient.bodyStat.attiveEIMS.length === 0) &&
      (patient.bodyStat.bio === null || patient.bodyStat.bio.length === 0) &&
      (patient.bodyStat.dateOfDiagnosis === null || patient.bodyStat.dateOfDiagnosis === '') &&
      (patient.bodyStat.familiarity === null || patient.bodyStat.familiarity === '') &&
      (patient.bodyStat.fiveASAOS === null || patient.bodyStat.fiveASAOS.length === 0) &&
      (patient.bodyStat.gcsOS === null || patient.bodyStat.gcsOS.length === 0) &&
      (patient.bodyStat.imm === null || patient.bodyStat.imm.length === 0) &&
      (patient.bodyStat.infiammatorioCD === null || patient.bodyStat.infiammatorioCD.length === 0) &&
      (patient.bodyStat.interventi === null || patient.bodyStat.interventi === '') &&
      (patient.bodyStat.localizzazioneUC === null || patient.bodyStat.localizzazioneUC.length === 0) &&
      (patient.bodyStat.locatColonCD === null || patient.bodyStat.locatColonCD.length === 0) &&
      (patient.bodyStat.locatIleumCD === null || patient.bodyStat.locatIleumCD.length === 0) &&
      (patient.bodyStat.locatUpperGI === null || patient.bodyStat.locatUpperGI.length === 0) &&
      (patient.bodyStat.malattiaPerianaleCD === null || patient.bodyStat.malattiaPerianaleCD.length === 0) &&
      (patient.bodyStat.numResezioni === null || patient.bodyStat.numResezioni === '') &&
      (patient.bodyStat.pathologyDuration === null || patient.bodyStat.pathologyDuration === ' years') &&
      (patient.bodyStat.penetranteCD === null || patient.bodyStat.penetranteCD.length === 0) &&
      (patient.bodyStat.sex === null || patient.bodyStat.sex === '') &&
      (patient.bodyStat.stenosanteCD === null || patient.bodyStat.stenosanteCD.length === 0) &&
      (patient.bodyStat.stomia === null || patient.bodyStat.stomia.length === 0) &&
      (patient.bodyStat.storicheEIMS === null || patient.bodyStat.storicheEIMS.length === 0) &&
      (patient.bodyStat.topica === null || patient.bodyStat.topica.length === 0)) {
      this.boolean = true;
    } else {
      this.boolean = false;
    }
    return this.boolean; */
  }

  findPatientsNoClinicalData(patients: Patient[]) {
    patients.forEach((patient) => {
      console.log(patient.ssn + patient.checkClinicalData)
      //se false, non sono stati inseriti
      if (patient.checkClinicalData == false)
        this.patientsNoClinicalData.push(patient);


      /*  patients.forEach((patient) => {
   
      if ((patient.bodyStat.age === null || patient.bodyStat.age === '' || patient.bodyStat.age === ' years') &&
  
      // tslint:disable-next-line:max-line-length
        (patient.bodyStat.ageOfDiagnosis === null || patient.bodyStat.ageOfDiagnosis === '' || patient.bodyStat.ageOfDiagnosis === ' years') &&
        (patient.bodyStat.attiveEIMS === null || patient.bodyStat.attiveEIMS.length === 0) &&
        (patient.bodyStat.therapyBIO === null || patient.bodyStat.therapyBIO.length === 0) &&
        (patient.bodyStat.dateOfDiagnosis === null || patient.bodyStat.dateOfDiagnosis === '') &&
        (patient.bodyStat.familiarity === null || patient.bodyStat.familiarity === '') &&
        (patient.bodyStat.therapy5ASAOS === null || patient.bodyStat.therapy5ASAOS.length === 0) &&
        (patient.bodyStat.therapyGCSOS === null || patient.bodyStat.therapyGCSOS.length === 0) &&
        (patient.bodyStat.therapyIMM === null || patient.bodyStat.therapyIMM.length === 0) &&
        (patient.bodyStat.infiammatorioCD === null || patient.bodyStat.infiammatorioCD.length === 0) &&
        (patient.bodyStat.interventi === null || patient.bodyStat.interventi === '') &&
        (patient.bodyStat.localizzazioneUC === null || patient.bodyStat.localizzazioneUC.length === 0) &&
        (patient.bodyStat.locatColonCD === null || patient.bodyStat.locatColonCD.length === 0) &&
        (patient.bodyStat.locatIleumCD === null || patient.bodyStat.locatIleumCD.length === 0) &&
        (patient.bodyStat.locatUpperGI === null || patient.bodyStat.locatUpperGI.length === 0) &&
        (patient.bodyStat.malattiaPerianaleCD === null || patient.bodyStat.malattiaPerianaleCD.length === 0) &&
        (patient.bodyStat.numResezioni === null || patient.bodyStat.numResezioni === '') &&
        (patient.bodyStat.pathologyDuration === null || patient.bodyStat.pathologyDuration === ' years') &&
        (patient.bodyStat.penetranteCD === null || patient.bodyStat.penetranteCD.length === 0) &&
        (patient.bodyStat.sex === null || patient.bodyStat.sex === '') &&
        (patient.bodyStat.stenosanteCD === null || patient.bodyStat.stenosanteCD.length === 0) &&
        (patient.bodyStat.stomia === null || patient.bodyStat.stomia.length === 0) &&
        (patient.bodyStat.storicheEIMS === null || patient.bodyStat.storicheEIMS.length === 0) &&
        (patient.bodyStat.therapyTOPICA === null || patient.bodyStat.therapyTOPICA.length === 0)) {
        this.patientsNoClinicalData.push(patient);
      } */
    }
    );
    this.dataSourceNoClinicalData = new MatTableDataSource<Patient>(this.patientsNoClinicalData);
  }

  selectNoClinicalDataPatients(event: MatCheckboxChange) {
    this.noClinicalDataSelection = false; // si pone a false
    if (event.checked === true) {
      this.noClinicalDataSelection = true;
      this.totalSize = this.patientsNoClinicalData.length;
      this.paginator.length = this.totalSize;
      this.dataSourceNoClinicalData.paginator = this.paginator;
      this.dataSourceNoClinicalData.paginator.firstPage();
    } else {
      this.noClinicalDataSelection = false;
      this.totalSize = this.patients.length;
      this.paginator.length = this.totalSize;
      this.dataSource.paginator = this.paginator;
      this.dataSource.paginator.firstPage();
    }
  }

  sendEmailToUCOtherPatinets() {
    try {
      this.sendingMail = true;
      this.doctorService.sendEmailToUCOtherPatinets()
        .subscribe((res) => {
          this.sendingMail = false;
          this.snackBar.open(res.body, 'Chiudi', {
            duration: 3000
          });
        }, (err) => {
          console.log(err)
          this.sendingMail = false;
        });
    }
    catch (er) {
      this.sendingMail = false;
    }
    finally {
      setTimeout(() => {
        this.sendingMail = false;
      }, 35000);
    }

  }
}
